import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled, css } from 'styled-components';
import { cssVar } from '../../theme/variables.js';
import { preventForwardPropsConfig } from '../../utils/preventForwardProps.js';
import { Item as Item$1 } from '@radix-ui/react-dropdown-menu';
import { mediaNotMobile, mediaMobile, mediaHover } from '../../constants/styled-utils.js';
import { MenuItemInfoIconTooltip } from '../Menu/MenuItemInfoIconTooltip.js';

const DropdownItemIconContainer = styled.div.withConfig({
  displayName: "Item__DropdownItemIconContainer",
  componentId: "sc-78fa6d4-0"
})([
  `align-items:center;justify-content:center;height:1.5rem;width:1.5rem;svg,svg[data-fabric-icon]{height:1.5rem;width:1.5rem;}`,
  `{&:first-child{margin-left:-8px;}`,
  `}`,
  `{display:flex;}`
], mediaNotMobile, (p) => css([
  `display:`,
  `;`
], p.nonMobileVisible ? "flex" : "none"), mediaMobile);
const cssDropdownItemMobile = css([
  ``,
  `{color:`,
  `;font-weight:500;background:`,
  ` !important;min-height:3.75rem;border-radius:0;font-size:0.9375rem;line-height:1.25em;padding:0 1rem;gap:1rem;align-items:center;display:flex;align-items:center;`,
  `{&:hover{border:none;}}&:not(:last-child){border-bottom:1px solid `,
  `;}&:first-child{border-top-left-radius:1rem;border-top-right-radius:1rem;}&:last-child{border-bottom-left-radius:1rem;border-bottom-right-radius:1rem;}`,
  ` kbd{display:none;}&[data-disabled]{cursor:not-allowed;color:`,
  `;}}`
], mediaMobile, cssVar["color-text-primary"], cssVar["color-bg-secondary-button"], mediaHover, cssVar["color-border-secondary"], (p) => p.variant === "danger" && css([
  `color:`,
  `;`
], cssVar["color-app-delete"]), cssVar["color-text-placeholder"]);
const cssDropdownItemNonMobile = css([
  `display:flex;justify-content:flex-start;align-items:center;width:fit-content;border-radius:6px;font-size:0.875rem;font-weight:500;height:max-content;min-height:2rem;width:100%;padding:0.25rem 0.625rem;overflow-wrap:anywhere;color:`,
  `;cursor:pointer;transition:background 150ms cubic-bezier(0.165,0.84,0.44,1);gap:8px;outline:none;min-width:170px;&:not([data-disabled]):is(:hover,:focus-visible,[data-keyboard-selected='true']){background-color:`,
  `;&:active{background-color:`,
  `;}}`
], cssVar["color-text-dropdown-item"], cssVar["color-bg-dropdown-item-hover"], cssVar["color-bg-dropdown-item-hover"]);
const DropdownItemBase = styled.button.attrs(({ iconElement, children, ...rest }) => {
  return {
    ...rest,
    children: /* @__PURE__ */ jsxs(Fragment, {
      children: [
        iconElement && /* @__PURE__ */ jsx(DropdownItemIconContainer, {
          children: iconElement
        }),
        children
      ]
    })
  };
}).withConfig(preventForwardPropsConfig([
  "iconElement",
  "variant"
])).withConfig({
  displayName: "Item__DropdownItemBase",
  componentId: "sc-78fa6d4-1"
})([
  ``,
  `;`,
  `;`,
  ` `,
  ` &[data-disabled]{cursor:not-allowed;color:`,
  ` !important;}&[data-selected='true']{background-color:`,
  `;}`
], cssDropdownItemNonMobile, cssDropdownItemMobile, (p) => p.variant === "danger" && css([
  `color:`,
  `;`
], cssVar["color-app-delete"]), (p) => p.disabled && css([
  `cursor:not-allowed;color:`,
  ` !important;`
], cssVar["color-text-placeholder"]), cssVar["color-text-placeholder"], cssVar["color-bg-dropdown-item-hover"]);
const Item = styled(DropdownItemBase).attrs(({ disabledReason, children, disabled, onClick, onSelect, ...props }) => {
  const isDisabled = !!disabledReason || disabled;
  return {
    ...props,
    disabled: isDisabled,
    onClick: isDisabled ? void 0 : onClick,
    onSelect: isDisabled ? void 0 : onSelect,
    as: Item$1,
    children: disabledReason ? /* @__PURE__ */ jsxs(Fragment, {
      children: [
        children,
        " ",
        /* @__PURE__ */ jsx(MenuItemInfoIconTooltip, {
          label: disabledReason
        })
      ]
    }) : children
  };
}).withConfig({
  displayName: "Item",
  componentId: "sc-78fa6d4-2"
})([
  ``
]);

export { DropdownItemBase, DropdownItemIconContainer, Item, cssDropdownItemMobile };
//# sourceMappingURL=Item.js.map
